import { Routes } from '@angular/router';
import {azureB2cGuard} from './app/core/guards/azure-b2c/azure-b2c.guard';
import {messageGuard} from './app/core/guards/message/message.guard';
import {redirectGuard} from './app/core/guards/redirect/redirect.guard';
import {ROUTES} from './routes.enum';
// MDOAH-ADAPTATION: re-export ROUTES so Work Queue files can import it from 'src/routes' (matches ILSOS' single routes barrel).
export {ROUTES} from './routes.enum';

export enum ROUTER_OUTLETS {
  REGISTER = 'registeroutlet',
  PASSWORD = 'passwordoutlet',
  SIDEPANEL_USERS = 'sidepanel-users',
  SIDEPANEL_HOME = 'sidepanel-home',
  SIDEPANEL_FILINGS = 'sidepanel-filings',
  SIDEPANEL_DOCKETS = 'sidepanel-dockets',
  // MDOAH-ADAPTATION: Named router outlets for the ported Work Queue feature (mirror ILSOS' queues outlets).
  QUEUE_MEMBERSHIP_PANEL = 'queue-membership-panel',
  QUEUES_SIDEPANEL = 'queues-sidepanel',
  QUEUES_CASE_DETAILS_SIDEPANEL = 'queues-case-details-side-panel',
}

/**
 * An interface to wrap http responses.
 * MDOAH-ADAPTATION: ported from ILSOS' routes.ts; used by the Work Queue resolvers/services.
 */
export interface Result<T> {
  data: T | undefined;
  error?: string;
}

export const APP_ROUTES: Routes = [
  {
    path: ROUTES.PUBLIC_DOCKET_SEARCH,
    title: 'MD OAH Docket Search',
    loadChildren: () => import('./app/pages/docket-search/docket-search.routes'),
  },
  {
    path: ROUTES.DOCUMENTS,
    title: 'Documents',
    loadComponent: () => import('./app/pages/documents/documents.component').then(m => m.DocumentsComponent),
    loadChildren: () => import('./app/pages/documents/documents.routes'),
  },
  {
    path: ROUTES.REGISTER,
    title: 'Registration',
    loadComponent: () => import('./app/pages/register/register.component').then(m => m.RegisterComponent),
    loadChildren: () => import('./app/pages/register/register.routes'),
  },
  {
    path: ROUTES.PASSWORD,
    title: 'Password',
    loadComponent: () => import('./app/pages/password/password.component').then(m => m.PasswordComponent),
    loadChildren: () => import('./app/pages/password/password.routes'),
  },
  {
    path: ROUTES.MESSAGE,
    title: 'Message',
    loadComponent: () => import('./app/pages/mesage/message.component').then(m => m.MessageComponent),
    canActivate: [
      messageGuard
    ]
  },
  {
    path: ROUTES.APP,
    title: 'MD OAH',
    canActivate: [
      redirectGuard,
      azureB2cGuard
    ],
    loadComponent: () => import('./app/pages/main/main.component').then(m => m.MainComponent),
    loadChildren: () => import('./app/pages/main/main.routes'),
  },
  { path: '', redirectTo: ROUTES.APP, pathMatch: 'full'},
  { path: '**', redirectTo: ROUTES.APP, pathMatch: 'full' },
]
